import { render, staticRenderFns } from "./NccContentColumn.vue?vue&type=template&id=c8c0ee32&scoped=true&"
import script from "./NccContentColumn.vue?vue&type=script&lang=js&"
export * from "./NccContentColumn.vue?vue&type=script&lang=js&"
import style0 from "./NccContentColumn.vue?vue&type=style&index=0&id=c8c0ee32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c0ee32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8c0ee32')) {
      api.createRecord('c8c0ee32', component.options)
    } else {
      api.reload('c8c0ee32', component.options)
    }
    module.hot.accept("./NccContentColumn.vue?vue&type=template&id=c8c0ee32&scoped=true&", function () {
      api.rerender('c8c0ee32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccContentColumn.vue"
export default component.exports